import { combineCostSources } from '../../utils'
import api from '../../client'

export let priceList

export let currencyFactor

/**
 * Set the currency to be used for calculating prices
 * @param {'eur' | 'usd'} currency
 */
export const setCurrencyFactor = (currency) => {
    currencyFactor = priceList.currency.factor[currency]
}

export const loadCalculator = async () => {
    try {
        priceList = await api.product.getPrices()
    } catch (error) {
        throw Error(
            'Could not reach the server, are you connected to the corporate network?'
        )
    }
}

/**
 * Calculates the estimated cost of running workers to upload data
 * @param {number} gb The amount of data to be processed in gigabytes
 * @param {number} hourlyCapacity The amount of data that can be processed in an hour in gigabytes
 */
export const calculateWorkerCost = (gb, hourlyCapacity) =>
    (gb / hourlyCapacity) * priceList.migration.price.hour * currencyFactor

export const calculateMigrationCost = (gb) => calculateWorkerCost(gb, 25)

export const calculateProxyRegenerationCost = (gb) =>
    calculateWorkerCost(gb, 50)

export const calculateRestoreCost = (gb) =>
    gb * priceList.quicklink.price.download.gb * 1.5 * currencyFactor

/**
 * Calculate the cost of using master delivery
 * @param {Object<string, number>} param0 Master delivery usage
 */
export const calculateMasterDeliveryCost = ({
    tier1,
    tier2,
    tier3,
    tier4,
    tier5,
    tier6
}) => {
    const {
        oneMinute,
        fiveMinutes,
        thirtyMinutes,
        sixtyMinutes,
        ninetyMinutes,
        oneTwentyMinutes
    } = priceList.masterDelivery
    const sources = {
        tier1: tier1 * oneMinute * currencyFactor,
        tier2: tier2 * fiveMinutes * currencyFactor,
        tier3: tier3 * thirtyMinutes * currencyFactor,
        tier4: tier4 * sixtyMinutes * currencyFactor,
        tier5: tier5 * ninetyMinutes * currencyFactor,
        tier6: tier6 * oneTwentyMinutes * currencyFactor
    }
    return {
        total: Math.round(combineCostSources(sources)),
        sources
    }
}
